import { dataHooks } from '@wix/data-hooks';

export const themePickerDataHooks = dataHooks<{
  defaultTheme: {};
  featuredTheme: { themeId: string };
}>('theme-picker');
